import { render, staticRenderFns } from "./TwPortAndPlaceVirtual.vue?vue&type=template&id=2385033f&"
import script from "./TwPortAndPlaceVirtual.vue?vue&type=script&lang=js&"
export * from "./TwPortAndPlaceVirtual.vue?vue&type=script&lang=js&"
import style0 from "./TwPortAndPlaceVirtual.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports